import { useData } from "./DataContext.js";

import TitlePageAda from "./TitlePage.Ada.js";
import TitlePage2cpo from "./TitlePage.2cpo.js";

export default function TitlePage (props)
{
    const gData = useData();
    switch (gData.gameId)
    {
	case "ada" : return (<TitlePageAda>{props.children}</TitlePageAda>);
	case "2cpo" : return (<TitlePage2cpo>{props.children}</TitlePage2cpo>);
	default : return (<></>);
    }
}

